<template>
	<AppHead title="Recordings" />

    <section class="px-4 xl:px-0 pb-8 pt-6 md:pt-0">
        <SectionHeading :title="room.title" />
    </section>

    <section class="px-4 xl:px-0 pb-16 pt-6 md:pt-0">
        <div v-if="room.recordings.length" class="grid w-full grid-cols-4 gap-5 mt-4">
            <RecordingCard v-for="recording in room.recordings" :recording="recording" :key="recording.uuid" />
        </div>

        <div v-else class="bg-white w-full flex items-center justify-center p-8 rounded-xl">
            <div class="w-auto h-32 md:h-64 flex flex-col space-y-5 items-center justify-center">
                <div class="flex flex-col items-center">
                    <svg class="w-8 h-8 mb-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"></path></svg>
                    <div class="text-sm font-medium">
                        No recordings, yet.
                    </div>
                    <Link preserve-state :href="route('recordings.create', room.uuid)" class="text-gray-700 text-sm text-center underline hover:no-underline">
                        Start your first recording now.
                    </Link>
                </div>
            </div>
        </div>
    </section>


</template>

<script setup>
import SectionHeading from '@/Shared/SectionHeading'
import { defineProps } from 'vue'
import RecordingCard from '@/Shared/RecordingCard'

const props = defineProps(['room'])

</script>

<script>
import Layout from '@/Shared/Layout'

export default {
    layout: Layout,
}
</script>